//extracted by mini-css-extract-plugin
export default {"container":"styles_container__WnEVz","backContainer":"styles_backContainer__QKDS3","heading":"styles_heading__qAUFc"};;